import { Flex, Tag, Tooltip, useDisclosure } from '@chakra-ui/react';
import { SourceTagsTooltipContent } from '~/apps/consumer/components/BuyerOfferAnalysis/KeyTermsAndContingencies/SourceTags';
import { SignalIcon, SignalStrength } from '~/common/icons/SignalIcon';
import { useListingPageContext } from '../../ListingPageContext';

export const DataSourceTooltip = ({
  label = 'Data source',
}: {
  label?: string;
}) => {
  const { includeIndigoData, confidence } = useListingPageContext();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Tooltip
      isOpen={isOpen}
      label={
        <SourceTagsTooltipContent
          confidence={confidence?.confidence as unknown as SignalStrength}
          distanceMiles={confidence?.maxDistanceMiles}
          priceRange={{
            min: confidence?.minClosePrice,
            max: confidence?.maxClosePrice,
          }}
          sourceLabel={includeIndigoData ? 'Indigo Accepted Offers' : 'MLS'}
          subType={confidence?.subType}
          timePeriodMonths={confidence?.maxTimePeriodMonths}
          zipCode={confidence?.zipCode}
        />
      }
      variant="muted"
    >
      <Flex alignItems="center" gap={2}>
        <Tag
          alignItems="center"
          borderRadius="5px"
          color="white"
          cursor="pointer"
          gap={2}
          size="sm"
          onClick={onOpen}
          onMouseEnter={onOpen}
          onMouseLeave={onClose}
        >
          {!!confidence?.confidence && (
            <SignalIcon
              color="purple.500"
              strength={confidence?.confidence as unknown as SignalStrength}
            />
          )}
          {label}
        </Tag>
      </Flex>
    </Tooltip>
  );
};
